import bgSpeed from '../../assets/images/app.png';
import groupImg from '../../assets/images/people.png';
import ServiceButton from '../ui/ServiceButton';

const PLAYSTORE_URL = 'https://play.google.com/store/apps/details?id=com.dp.speedyssey';
const APPSTORE_URL = 'https://apps.apple.com/app/speedyssey/id6448916710';
import playstoreImg from '../../assets/images/play_store.svg';
import appstoreImg from '../../assets/images/app_store.svg';
  const handleDownload = () => {
    const userAgent = navigator.userAgent || navigator.vendor;

    if (/android/i.test(userAgent)) {
      window.open(
        "https://play.google.com/store/apps/details?id=com.dp.speedyssey",
        "_blank",
      );
    } else if (/iPad|iPhone|iPod/.test(userAgent)) {
      window.open("https://apps.apple.com/app/speedyssey", "_blank");
    } else {
      // Desktop fallback
      window.open(
        "https://play.google.com/store/apps/details?id=com.dp.speedyssey",
        "_blank",
      );
    }
  };
function Hero() {
  return (
    <section
      id="overview"
      className="container mx-auto px-4 lg:px-8 py-10 lg:py-12"
    >
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-6 sm:mt-16">
        {/* Left Card */}
        <div
          className="relative mt-[-40px] sm:mt-0 rounded-xl sm:rounded-[2.5rem] overflow-hidden flex flex-col justify-between min-h-[320px] md:min-h-[420px] lg:min-h-[480px] bg-[#2C2C2C] -lg"
        >
          {/* Copy */}
          <div className="p-6 md:p-8 space-y-5 max-w-lg">
            <h1 className="text-white text-4xl md:text-4xl lg:text-5xl font-bold leading-tight">
              Drive, Deliver,
              <br />and Earn on your
              <br />schedule.
            </h1>
            <p className="text-gray-200 text-base md:text-lg max-w-md">
              We connect you with businesses who need fast, local deliveries. You focus on the road, we handle the rest.
            </p>
            {/* Mobile: Show two store buttons, Desktop: Show single ServiceButton */}
            <div>
              {/* Mobile (smaller than md): flex, md+: hidden */}
              <div className="flex flex-row justify-between gap-2 md:hidden w-full">
                <a
                  href={PLAYSTORE_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex-1 w-full"
                  style={{ display: 'block' }}
                >
                  <img
                    src={playstoreImg}
                    alt="Get it on Google Play"
                    className="h-10 w-full object-contain"
                    style={{ maxWidth: '100%' }}
                  />
                </a>
                <a
                  href={APPSTORE_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex-1 w-full"
                  style={{ display: 'block' }}
                >
                  <img
                    src={appstoreImg}
                    alt="Download on the App Store"
                    className="h-10 w-full object-contain"
                    style={{ maxWidth: '100%' }}
                  />
                </a>
              </div>
              {/* Desktop (md+): show ServiceBuftton */}
              <div className="hidden md:block">
                <ServiceButton title="Download App" variant="orange" onClick={handleDownload} />
              </div>
            </div>
          </div>
          {/* Footer Image */}
          <div className="w-full mt-auto">
            <img
              src={groupImg}
              alt="Delivery Partner"
              className="w-full object-cover"
              style={{ display: 'block' }}
            />
          </div>
        </div>

        {/* Right Card */}
        <div
          className="relative rounded-xl sm:rounded-[2.5rem] border border-gray-200 overflow-hidden flex items-center justify-center p-4 min-h-[320px] md:min-h-[420px] lg:min-h-[480px] -lg"
          style={{
            backgroundImage: `url(${bgSpeed})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
        </div>
      </div>
    </section>
  );
}

export default Hero;
